// front/src/admin/AdminOrders.jsx
import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchOrders } from '../../api/admin/ordersApi';
import { labelOrderStatus } from '../../utils/orderStatus';
import './AdminOrders.css';

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const source = searchParams.get('source') || 'all';
  const status = searchParams.get('status') || 'all';

  const attention = searchParams.get('attention') || '';

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await fetchOrders({
          source: source === 'all' ? undefined : source,
          status: status === 'all' ? undefined : status,
          attention: attention === '1' ? '1' : undefined,
        });
        setOrders(data);
      } catch (e) {
        console.error(e);
        alert('Ошибка при загрузке заказов');
      } finally {
        setLoading(false);
      }
    })();
  }, [source, status, attention]);

  const handleFilterChange = (key, value) => {
    const next = new URLSearchParams(searchParams);
    if (value === 'all') next.delete(key); else next.set(key, value);
    setSearchParams(next);
  };

  return (
    <div>
      <h2 className="admin-page-title">Заказы</h2>

      <div className="filters-row">
        <label>
          Источник:
          <select value={source} onChange={e => handleFilterChange('source', e.target.value)}>
            <option value="all">Все</option>
            <option value="website">С сайта</option>
            <option value="manual">Касса</option>
          </select>
        </label>

        <label>
          Статус:
          <select value={status} onChange={e => handleFilterChange('status', e.target.value)}>
            <option value="all">Все</option>
            <option value="new">Новый</option>
            <option value="reserved">В резерве</option>
            <option value="paid">Оплачен</option>
            <option value="in_progress">В работе (оплачен/сборка/отправка)</option>
            <option value="assembling">Сборка</option>
            <option value="shipped">Отправлен</option>
            <option value="delivered">Доставлен</option>
            <option value="completed">Завершён</option>
            <option value="cancelled">Отменён</option>
          </select>
        </label>

        <label>
          <input
            type="checkbox"
            checked={attention === '1'}
            onChange={(e) => handleFilterChange('attention', e.target.checked ? '1' : 'all')}
          />{' '}
          Требует внимания
        </label>
      </div>

      {loading && <p>Загрузка...</p>}

      {!loading && (
        <table className="admin-table">
          <thead>
            <tr>
              <th>№</th>
              <th>Дата</th>
              <th>Источник</th>
              <th>Покупатель</th>
              <th>Телефон</th>
              <th>Сумма</th>
              <th>Оплата</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {orders.map(o => {
              const sum = o.total || o.items?.reduce((s, i) => s + i.qty * i.price, 0) || 0;
              return (
                <tr key={o._id}>
                  <td><Link to={`/admin/orders/${o._id}`}>{o.number}</Link></td>
                  <td>{new Date(o.createdAt).toLocaleString('ru-RU')}</td>
                  <td>
                    <span className={`admin-badge admin-badge--${o.source}`}>
                      {o.source === 'website' ? 'С сайта' : 'Касса'}
                    </span>
                  </td>
                  <td>{o.buyer?.name}</td>
                  <td>{o.buyer?.phone}</td>
                  <td>{Number(sum).toFixed(2)}</td>
                  <td>{o.payment?.status || '—'}</td>
                  <td>
                    <span className={`admin-badge admin-badge--${o.status}`}>
                      {labelOrderStatus(o.status)}
                    </span>
                    {o.needsAttention && (
                      <span className="admin-badge admin-badge--cancelled" style={{ marginLeft: 6 }}>
                        внимание
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
}
